/*
  Plain +/- quantity stepper for the flavor cards' own buy form (see
  sections/highrise-home-flavor-stack.liquid). Deliberately not Dawn's
  own <quantity-input> custom element: that one is wired for the CART's
  line-item update form specifically (name="updates[variant_id]", and
  depends on cart-specific JS context) — these buttons sit in a product
  ADD-TO-CART form instead (plain name="quantity"), a different job, so
  a small self-contained stepper here avoids dragging in a dependency
  built for a different form shape.
*/
(function () {
  function clampToMin(input) {
    var min = parseInt(input.min, 10) || 1;
    var value = parseInt(input.value, 10);
    if (isNaN(value) || value < min) value = min;
    input.value = value;
  }

  function init(stepper) {
    var input = stepper.querySelector('.hn-qty-stepper__input');
    var minus = stepper.querySelector('[data-qty-minus]');
    var plus = stepper.querySelector('[data-qty-plus]');
    if (!input || !minus || !plus) return;

    minus.addEventListener('click', function () {
      clampToMin(input);
      input.value = parseInt(input.value, 10) - 1;
      clampToMin(input);
    });
    plus.addEventListener('click', function () {
      clampToMin(input);
      input.value = parseInt(input.value, 10) + 1;
    });
    input.addEventListener('change', function () {
      clampToMin(input);
    });
  }

  document.querySelectorAll('[data-qty-stepper]').forEach(init);
})();
